export default [
  '35th Reunion',
  '40th Reunion',
  '45th Reunion',
  '50th Reunion'
]
